module.exports = __webpack_public_path__ + "static/media/Wellness04.fd21bedd.jpeg";